// extracted by mini-css-extract-plugin
export default {"videoCarousel":"styles_videoCarousel__DoIqz","sliderItem":"styles_sliderItem__cxYBx","backdrop":"styles_backdrop__zRTSn","playBtnWrapper":"styles_playBtnWrapper__uECsX"};